import moment from "moment";
import { FC } from "react";
import Chart from "react-apexcharts";
import { useTranslation } from 'react-i18next';

interface IProps {
  data: any;
}

const ChartContainer: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ width: '100%', height: '70vh' }}>
      <Chart
        type="line"
        height="100%"
        options={{
          chart: {
            toolbar: { show: false }
          },
          xaxis: {
            categories: data?.map((item: any) => moment(item.day).format('YYYY.MM.DD')),
          }
        }}
        series={[
          {
            name: t('student.student.option6'),
            data: data?.map((item: any) => item.parentCount),
          },
          {
            name: t('common.menu.student'),
            data: data?.map((item: any) => item.studentCount),
          },
        ]}
      />
    </div>
  );
}

export default ChartContainer;
